import { render, staticRenderFns } from "./policyDocumentsList.vue?vue&type=template&id=3fdaf957&scoped=true&lang=html"
import script from "./policyDocumentsList.vue?vue&type=script&lang=js"
export * from "./policyDocumentsList.vue?vue&type=script&lang=js"
import style0 from "./policyDocumentsList.vue?vue&type=style&index=0&id=3fdaf957&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdaf957",
  null
  
)

export default component.exports